<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  data() {
    return {
      drawer:false,
      drawerTop: 0,
      menuTextColor:"",
      currentLang:"en",
      langMap: {
        en: 'Eng',
        'zh-HK': '繁',
        'zh-CN': '简'
      },
      langOptions:[
        {value:'en',label:'Eng'},
        {value:'zh-HK',label:'繁'},
        {value:'zh-CN',label:'简'},
      ]
    }
  },
  computed:{
    menuItem(){
      return [
        { path: '/', name: this.$t('menu.home')},
        { path: '/About', name: this.$t('menu.about')},
        { path: '/Partners', name: this.$t('menu.partners'),},
        { path: '/About#mt-app-section', name: 'Monkey Tree App'},
        { path: '/ContactUs', name: this.$t('menu.contact')}
      ]
    },
    currentLangLabel() {
      return this.langMap[this.currentLang] || 'en';
    }
  },
  methods: {
    getLocalLang(){
      const lang = localStorage.getItem('lang')
      if(lang){
        this.$i18n.locale = lang
        this.currentLang = lang
      }else{
        this.$i18n.locale = 'en'
      }
    },
    handleLangChange(langCode){
      this.currentLang  = langCode
      this.$i18n.locale = langCode;
      localStorage.setItem('lang', langCode)
    },
    openDrawer(){
      this.drawer = !this.drawer
      this.drawerTop = this.$refs.headerRef.offsetHeight
    },
    handleItemClick(event, path){
      const target = event.target
      if (target.tagName.toLowerCase() === 'span') {
        this.$router.push(path).catch(err => {
          if(err.name !== 'NavigationDuplicated'){
            throw err
          }
        })
        this.drawer = false
      }
    },
    isActive(path) {
      return this.$route.path === path
    }
  },
  created() {
    this.getLocalLang()
  },
}
</script>

<template>
<div>
  <div class="header-container" ref="headerRef">
    <div class="header-logo-box" @click="() => $router.push({path: '/'})" style="cursor: pointer;">
      <img src="@/assets/images/home/pp_logo_s.png" alt="">
    </div>
    <div class="header-menu d-xs-block d-lg-none">
      <el-menu
          :default-active="$route.path"
          router
          class="menu"
          active-text-color="#009344"
      >
        <el-menu-item v-for="item in menuItem" :index="item.path" :key="item.path">{{item.name}}</el-menu-item>
        <el-dropdown class="lang-box" trigger="click" @command="handleLangChange">
          <span class="el-dropdown-link">
            {{currentLangLabel}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  :class="{'active-item' : item.value === currentLang}" v-for="(item, index) in langOptions" :command="item.value" :key="index">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu>

    </div>
    <div class="mobile-collapse d-xs-none d-lg-block" @click="openDrawer">
      <img v-if="!drawer" class="vertical-middle" src="@/assets/images/icon/col.svg" alt="">
      <img v-else class="vertical-middle" src="@/assets/images/icon/close.svg" alt="">
    </div>
    <el-drawer
        class="custom-drawer"
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
        direction="ttb"
        :modal="false"
        :modal-append-to-body="false"
        :style="{ top: drawerTop + 'px' }"
    >
      <el-menu class="mobile-menu">
        <el-menu-item v-for="item in menuItem" :index="item.path" :key="item.path" @click.native.prevent="handleItemClick($event, item.path)">
          <span :class="{'active': isActive(item.path)}">{{item.name}}</span>
        </el-menu-item>
        <el-dropdown class="lang-box" trigger="click" @command="handleLangChange">
          <span class="el-dropdown-link">
            {{currentLangLabel}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  :class="{'active-item' : item.value === currentLang}" v-for="(item, index) in langOptions" :command="item.value" :key="index">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu>
    </el-drawer>
  </div>

</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.header-container{
  width: 100%;
  padding: 6px 197px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  background-color: rgba(255, 255, 255, 0.71);
  z-index: 1000;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
  @include media-max(xxl){
    padding: 6px 100px;
  }
  @include media-max(xl){
    padding: 6px 25px;
  }
  @include media-max(lg){
    padding: 6px 37px;
    box-shadow: none;
  }
  @include media-max(md){
    padding: 26px 37px;
  }
  @include media-max(sm){
    padding: 14px 23px;
    .header-logo-box{
      img{
        width: 169px;
      }
    }
    .mobile-collapse{
      img{
        width: 18px;
      }
    }
  }
  .header-menu{
    .menu{
      display: flex;
      column-gap: 50px;
      align-items: center;
    }
  }
  ::v-deep(.custom-drawer){
    .el-drawer{
      opacity: 71%;
      height: auto !important;
      .el-drawer__body{
        padding: 24px 0 24px 53px;
        .mobile-menu{
          .el-menu-item{
            height: auto;
            line-height: 32px;
            cursor: default;
            background: transparent;
            span{
              color: #5A2A00;
              &.active {
                color: #009344;
              }
            }
          }
          .lang-box{
            padding-left: 20px;
            color: #5A2A00;
          }
        }
      }
    }
  }

}
.menu{
  background: transparent;
  border: none;
  .el-menu-item{
    padding: 0 !important;
    font-size: 17px;
    background: transparent;
    &:hover{
      color: #009344 !important;
      background: transparent;
    }
  }
  .el-dropdown{
    span{
      font-size: 17px;
      color: #303133;
      cursor: pointer;
    }
  }

}

</style>